<template>
  <div
    class="image-container pa-6 flex col justify-between"
    :style="`background-image: url(${photo.src});`"
    :aria-label="$t(photo.alt!)"
  >
    <h4 class="text-white">{{ $tt(photo.desc!) }}</h4>
    <MobileOnly class="desc-wrapper bg-white py-2 px-5">
      <p>{{ text }}</p>
    </MobileOnly>
  </div>
</template>

<script setup lang="ts">
import type { Image } from '~/types';
defineProps<{
  photo: Image;
  text: string;
}>();
</script>

<style lang="scss" scoped>
.image-container {
  position: relative;
  background-size: cover;
  background-position: center;
  border-radius: var(--border-r-lg);
  height: 306px;
  width: 460px;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(
      to bottom right,
      rgba(0, 0, 0, 0.4) 0%,
      rgba(0, 0, 0, 0.4) 40%,
      rgba(0, 0, 0, 0) 100%
    );
    pointer-events: none;
    z-index: 1;
    border-radius: var(--border-r-lg);
  }
  h4, .desc-wrapper {
    position: relative;
    z-index: 2;
  }
}

@media (min-width: 851px) and (max-width: 1200px) {
  .image-container {
    min-width: 240px;
  }
}

@media (max-width: 850px) {
  .image-container {
    width: 100%;
    height: 276px;
    padding: var(--space-4) !important;
    h4 {
      font-size: 16px;
    }
    .desc-wrapper {
      border-radius: var(--border-r-md);
      p {
        font-weight: 500;
        font-size: 12px;
        margin-bottom: 0;
      }
    }
  }
}
</style> 